import BaseUAParser from 'ua-parser-js';
import { compareVersions } from 'compare-versions';

/**
 * Extension of the base UserAgent parser which allows to check the user agent against browserslist entries
 */
export default class UAParser extends BaseUAParser {
    getBrowserIdentifier() {
        const browser = this.getBrowser();
        const os = this.getOS();

        if (browser.name === 'Android Browser') {
            return 'android';
        }

        if (os.name === 'BlackBerry') {
            return 'bb';
        }

        if (browser.name === 'Chrome' && os.name === 'Android') {
            return 'and_chr';
        }

        if (browser.name === 'Firefox' && os.name === 'Android') {
            return 'and_ff';
        }

        if (browser.name === 'IEMobile') {
            return 'ie_mob';
        }

        if (browser.name === 'Opera Mobi') {
            return 'op_mob';
        }

        if (browser.name === 'Safari' && os.name === 'iOS') {
            return 'ios_saf';
        }

        if (browser.name === 'UCBrowser') {
            return 'and_uc';
        }

        return browser.name.toLowerCase();
    }

    isSupported(supportedBrowsers) {
        return !!supportedBrowsers.find(identifier => identifier.includes(this.getBrowserIdentifier()));
    }

    isUpToDate(supportedBrowsers) {
        if (!this.isSupported(supportedBrowsers)) return false;

        // Semver only supports 3 parts
        const currentVersion = this.getBrowser().version.split('.').slice(0, 3).join('.');
        const currentVersionArray = currentVersion.split('.');
        const currentBrowserIdentifier = this.getBrowserIdentifier();

        while (currentVersionArray.length) {
            const versionIdentifier = `${currentBrowserIdentifier} ${currentVersionArray.join('.')}`;
            if (supportedBrowsers.includes(versionIdentifier)) return true;
            currentVersionArray.pop();
        }

        const newestVersion = supportedBrowsers
            .filter(identifier => identifier.includes(currentBrowserIdentifier))
            .map(identifier => identifier.match(/.* (.*)/)[1])
            .sort(compareVersions)
            .pop();

        return compareVersions(currentVersion, newestVersion) >= 0;
    }
}
